export default "__VITE_ASSET__CaZJFHg4__"